import MarketplaceItemDescriptionTab from './MarketplaceItemDescriptionTab'

export default MarketplaceItemDescriptionTab
